import {
  CREATE_KEYNOTE_IMAGE_REQUEST,
  CREATE_KEYNOTE_IMAGE_SUCCESS,
  CREATE_KEYNOTE_IMAGE_FAILURE,
  UPDATE_KEYNOTE_IMAGE_REQUEST,
  UPDATE_KEYNOTE_IMAGE_SUCCESS,
  UPDATE_KEYNOTE_IMAGE_FAILURE,
  DELETE_KEYNOTE_IMAGE_REQUEST,
  DELETE_KEYNOTE_IMAGE_SUCCESS,
  DELETE_KEYNOTE_IMAGE_FAILURE,
} from "../actions/types";

import ResponseService from "../../utils/ResponseService";
import ApplicationError from "../../utils/ApplicationError";

const initialState = {
  image: undefined,
  error: ApplicationError.buildDefault(),
  isFetching: false,
  ...ResponseService.defaultPaginationMetaData(),
};

const imagesReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create
    case CREATE_KEYNOTE_IMAGE_REQUEST:
      return { ...state, isFetching: true };
    case CREATE_KEYNOTE_IMAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        image: action.payload,
        error: ApplicationError.buildDefault(),
      };
    case CREATE_KEYNOTE_IMAGE_FAILURE:
      return { ...state, isFetching: false, error: action.payload };

    // Update
    case UPDATE_KEYNOTE_IMAGE_REQUEST:
      return { ...state, isFetching: true };
    case UPDATE_KEYNOTE_IMAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        image: action.payload,
        error: ApplicationError.buildDefault(),
      };
    case UPDATE_KEYNOTE_IMAGE_FAILURE:
      return { ...state, isFetching: false, error: action.payload };

    // Delete
    case DELETE_KEYNOTE_IMAGE_REQUEST:
      return { ...state, isFetching: true };
    case DELETE_KEYNOTE_IMAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: ApplicationError.buildDefault(),
      };
    case DELETE_KEYNOTE_IMAGE_FAILURE:
      return { ...state, isFetching: false, error: action.payload };

    default:
      return state;
  }
};

export default imagesReducer;
